(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("pdfjs-dist/build/pdf.combined", [], factory);
	else if(typeof exports === 'object')
		exports["pdfjs-dist/build/pdf.combined"] = factory();
	else
		root["pdfjs-dist/build/pdf.combined"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition